module.exports = __webpack_public_path__ + "img/weather2_lower.87e225dd.png";